import {
    HttpResponse,
    MeasureModel,
    QueryModel,
    RequestParams,
    MeasureModelIEnumerableApiResultSuccess,
    MeasureModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class MeasuresDataService implements CrudService<MeasureModel, MeasureModel> {
    getAll(query: CrudDataQuery<MeasureModel>): Promise<CrudEnumerableResponse<MeasureModel>> {
        return ApiService.api.getMeasureBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<MeasureModel>): Promise<CrudEnumerableResponse<MeasureModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<MeasureModel>> {
        return ApiService.api.getMeasureById(id, params);
    }

    create(item: MeasureModel, params?: RequestParams): Promise<CrudResponse<MeasureModel>> {
        return ApiService.api.insertMeasure(item, params);
    }

    update(item: MeasureModel, params?: RequestParams): Promise<MeasureModel> {
        return ApiService.api.updateMeasure(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<MeasureModel> {
        return ApiService.api.patchMeasure(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<MeasureModel>): Promise<CrudEnumerableResponse<MeasureModel>> {
        return ApiService.api.deleteMeasures(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationMeasure(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<MeasureModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        return ApiService.api.exportMeasureBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    clone(item: MeasureModel, params?: RequestParams): Promise<CrudResponse<MeasureModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getMeasureGroupped(query, params);
    }

}
